import React from 'react';
const IconFormAddCircleOutlined = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7Z" fill="#2D2E2E"/>
<path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconFormAddCircleOutlined;